import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f5b0414"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xag-container" }
const _hoisted_2 = { class: "main-wrap" }
const _hoisted_3 = { class: "search-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "xag-flex",
  style: {"height":"100%","align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/general_icon_search_24.svg",
    style: {"height":"18px"}
  })
], -1))
const _hoisted_5 = { class: "error-tips" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "radio-item" }
const _hoisted_8 = { class: "popup-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-tip top-tip" }, " 可根据下列可选服务类型前往具备维修资质的服务网点进行维修！ ", -1))
const _hoisted_10 = { class: "description-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-item-title" }, "可选服务", -1))
const _hoisted_12 = { class: "description-item-content" }
const _hoisted_13 = {
  key: 0,
  class: "description-item"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-item-title" }, "定责初判", -1))
const _hoisted_15 = { class: "description-item-content" }
const _hoisted_16 = {
  key: 1,
  class: "description-item"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-item-title" }, "故障现象综合分析", -1))
const _hoisted_18 = { class: "description-item-content" }
const _hoisted_19 = {
  key: 2,
  class: "description-item"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-item-title" }, "故障附图", -1))
const _hoisted_21 = { class: "description-item-content" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "description-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description-item-title" }, "权益提醒", -1))
const _hoisted_25 = { class: "description-item-content" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-tip bottom-tip" }, " 报告说明：本报告由系统自动分析生成，可快速获取基础结论。如需人工开展详细数据分析，可申请人工定责服务 ", -1))

import { useStore } from 'vuex'
import { AxiosError } from 'axios'
import { getMap } from '@/utils/maptalkFactory'
import { useRoute, useRouter } from 'vue-router'
import { ref, onMounted, Ref, computed, nextTick } from 'vue'
import { Map as MaptalksMap, VectorLayer, Marker, Layer, Coordinate } from 'maptalks'
import { MalfunctionRepairDeviceItem } from '@/types/malfunction-repair'
import { Search, PullRefresh, List, Radio, RadioGroup, Popup } from 'vant'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair/index'
import {
  getRepairWarehouseList,
  changeOrderRepairWahouse,
  getIsSiteSubmission,
  createOrder,
} from '@/apis/malfunction-repair'
import type { GetWarehouseListResult } from '@/types/malfunction-repair'
import {
  MalfunctionRepairOrderDetailStorage,
  MalfunctionRepairSelectedDevicesStorage,
} from '@/storage/malfunction-repair'
import { QUALITY } from '@/defination/malfunction-repair'
import { isAuthWarehouse } from '@/defination/malfunction-repair'
import {
  GetWarehouseListItemType,
  GetWarehouseListParams,
  NetworkListRenderItem,
  CreateMulfunctionRepairOrderParams,
} from '@/types/malfunction-repair'
import AppHeader from '@/components/Header.vue'
import getMapSiteInfo from '@/compositions/map/index'
import PopupHeader from '@/components/popup/popup-header.vue'
import NetworkInfoItem from './components/network-info-item.vue'
import CommonImagePreview from '@/components/CommonImagePreview.vue'
import NetworkHeaderTips from './components/network-header-tips.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import useCommonList, { PageListResut, useListScrollHandle } from '@/compositions/useCommonList'
import ServiceTag from './components/service-tag.vue'
import { NO } from '@/defination/malfunction-repair'
import RightReminder from './components/right-reminder.vue'
import appHost from '@/utils/app'
import { clearToast, showConfirmModal, showNormalToast, showToastLoading } from '@/utils/tools'

type PopupInfo = {
  serviceType: Array<string>
  liabilityJudgment?: Array<{
    text: string
    flag: boolean
  }>
  authTip: Array<{
    text: string
    flag: boolean
  }>
  description: string
  images: string[]
}

import { defineComponent } from 'vue'
import { showToastSuccess } from '@/utils/tools'
import { commonErrorHandle } from '@/utils/error-handle'
import OnSiteBillLadingTipDialog from './components/on-site-bill-lading-tip-dialog.vue'
import OnSiteSystemTipDialog from './components/on-site-system-tip-dialog.vue'
import app from '@/utils/app'

const __default__ = defineComponent({
  name: 'malfunction-repair-network-list',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

// 选择维修网点
const $store = useStore()
const $route = useRoute()
const $router = useRouter()
const guid = $route.query.guid as string
const warningGuid = $route.query.warningGuid as string
// 已选择的网点id，用于回填时使用
const selectedWarehouseGuid = $route.query.selectedWarehouseGuid as string
const orderGuid = $route.query.orderGuid as string
const sn = $route.query.sn as string
const is_boom = $route.query.is_boom as string
const keywords: Ref<string> = ref('')
const showPopup = ref(false)
const is_uav = $route.query.is_uav as string
const box = ref<HTMLElement>()
const errorMessage = ref('')
const locationInfo: Ref<{
  lng?: number
  lat?: number
}> = ref({})

let { mapZoom, mapCenter } = getMapSiteInfo()
let map: MaptalksMap = null
let layer: Layer = null
let marker: Marker = null
const from = $route.query.from as string
const selectedValue = ref(selectedWarehouseGuid || '')

let OnSiteBillLadingTipDialogRef = ref<InstanceType<typeof OnSiteBillLadingTipDialog>>()
let OnSiteSystemTipDialogRef = ref<InstanceType<typeof OnSiteSystemTipDialog>>()

function goBack() {
  $router.go(-1)
}

const isPay = $route.query.isPay as string
const popupInfo = ref<PopupInfo>({
  serviceType: [],
  liabilityJudgment: [],
  authTip: [],
  description: '',
  images: [],
})
const canShowFualtInfo = computed(() => {
  return !!popupInfo.value.description || !!popupInfo.value.images.length
})
const hasWarningGuid = computed(() => {
  return !!warningGuid
})
const isPlan = computed(() => {
  const devices: Array<MalfunctionRepairDeviceItem> = MalfunctionRepairSelectedDevicesStorage.get()
  return devices?.[0].type === 1 || !!is_uav
})

const isShowLiabilityJudgment = computed(() => {
  return !!$route.query.guid && popupInfo.value.liabilityJudgment.length
})

let validateOnSiteExemption = ref(0)
let remainNum = ref(0)

let on_site_exemption = ref(0)

function continueHandle() {
  if (validateOnSiteExemption.value === 1) {
    OnSiteSystemTipDialogRef.value.setShow(true)
  }
}

function qualitativeHandle(data?: GetWarehouseListResult, guid?: string) {
  if (data) {
    // 定责日志分析后显示提示
    if (Number(isPay) !== 1) {
      showPopup.value = true
    }
    popupInfo.value.serviceType = [data.qualitative.service_type]
    popupInfo.value.description = data.qualitative.description || ''
    popupInfo.value.images = data.qualitative.images || []
    if (data.qualitative.service_type !== NO) {
      // 添加付费服务
      popupInfo.value.serviceType.push(NO)
    }
    let display = data.qualitative.display || []
    // 植保机有日志
    if (guid) {
      let responsibility = display.find((_) => _.type === 'responsibility')
      console.log('responsibility', responsibility)
      responsibility &&
        (popupInfo.value.liabilityJudgment = [
          {
            text: responsibility.title,
            flag: !!responsibility.status,
          },
        ])
    }
    let authTip = display
      .filter((_) => _.type !== 'responsibility')
      .map((_) => {
        return {
          text: _.title,
          flag: !!_.status,
        }
      })
    popupInfo.value.authTip = authTip
  }
}

async function onSiteSystemTipDialogConfirm(value: number) {
  on_site_exemption.value = value
  // 查询权益
  try {
    showToastLoading()
    let params = getParam()
    const data = await getRepairWarehouseList({
      ...params,
      keywords: keywords.value,
      serial_number: sn,
      lat: locationInfo.value.lat,
      lng: locationInfo.value.lng,
      logs: [guid].filter((item) => item),
      is_boom: is_boom === 'true',
      is_on_site_exemption: value,
    })
    qualitativeHandle(data)
  } catch (e) {
    commonErrorHandle(e)
  }
  clearToast()
}
const {
  addNetworkListKeepAlive,
  removeServiceOrderKeepAlive,
  setNetworkInfo,
  malfunctionRepairState,
  getUserLocation,
} = useMalfunctionRepairStore()

async function queryList(
  params: GetWarehouseListParams
): Promise<PageListResut<NetworkListRenderItem>> {
  try {
    const query = {
      ...params,
      keywords: keywords.value,
      serial_number: sn,
      lat: locationInfo.value.lat,
      lng: locationInfo.value.lng,
      logs: [guid].filter((item) => item),
      is_boom: is_boom === 'true',
    }
    console.log('query', query)
    const data = await getRepairWarehouseList(query)
    // 置顶数据每一页都是一样的, 所以只在第一页的时候处理
    let isFirst = params.page === 1
    if (isFirst && isPlan.value && !from) {
      if (guid && !warningGuid) {
        let getIsSiteSubmissionData = await getIsSiteSubmission({
          serial_number: sn,
          lat: locationInfo.value.lat,
          lng: locationInfo.value.lng,
          is_boom: is_boom === 'true',
          log: guid,
        })
        validateOnSiteExemption.value = getIsSiteSubmissionData.on_site_exemption
        remainNum.value = getIsSiteSubmissionData.on_site_exemption_num
        if (!getIsSiteSubmissionData.is_on_site) {
          OnSiteBillLadingTipDialogRef.value.setShow(true)
        } else {
          qualitativeHandle(data, guid)
        }
      } else {
        qualitativeHandle(data, guid)
      }
    }
    let resultData = data.data.filter((_) => !data.top.find((topItem) => topItem.guid === _.guid))
    const list = (isFirst ? data.top || [] : []).concat(resultData)
    const result: PageListResut<NetworkListRenderItem> = {
      ...data,
      data: list,
    }
    if (isFirst) {
      selectedValue.value = selectedWarehouseGuid || (list[0] && list[0].guid) || ''
      const selectedItem = list.filter((item) => item.guid === selectedValue.value)[0]
      if (selectedItem) {
        setMarker([selectedItem.lng, selectedItem.lat])
      }
    }
    return result
  } catch (errorData: unknown) {
    const error = errorData as AxiosError
    const errorObj = error?.response?.data || error
    const message = errorObj?.message || '网络异常，请稍后再试'
    errorMessage.value = message
    return Promise.reject(error)
  }
}
const {
  refreshing,
  loading,
  requestError,
  finished,
  onRefresh,
  resetSearch,
  dataList,
  queryHandle,
  finishedText,
  setLoading,
  getParam,
} = useCommonList<NetworkListRenderItem, GetWarehouseListParams>(queryList, {
  emptyText: '查无该网点或已知网点无当前设备的维修权限',
})
function keywordChangeHandle() {
  resetSearch()
}
function setMarker(center: number[]) {
  if (!marker) {
    marker = new Marker(center, {
      id: Date.now().toString(),
      editable: false,
      interactive: false,
      symbol: {
        markerFile: '/images/icon_weizhi.png',
        markerWidth: 40,
        markerHeight: 40,
        scale: 1,
        textFill: 'rgba(255,255,255,1)',
        textSize: 12,
        textWeight: 500,
        textHaloFill: '#222',
        textHaloRadius: 1,
        textHaloOpacity: 0.6,
      },
    })
    marker.addTo(layer)
  }
  marker.setCoordinates(center)
  map.setCenter(new Coordinate(center))
}
function initMap() {
  map = getMap(box.value, {
    center: mapCenter.value,
    zoom: mapZoom.value,
    attribution: false,
    tidituType: '地形注记',
  })
  layer = new VectorLayer(Date.now().toString()).addTo(map)
  console.log('isFirst', 222)
  if (selectedValue.value) {
    // set
    const selectedItem = dataList.value.filter((item) => item.guid === selectedValue.value)[0]
    if (selectedItem) {
      setMarker([selectedItem.lng, selectedItem.lat])
    }
  }
}

async function listItemClick(data: GetWarehouseListItemType) {
  if (isAuthWarehouse(data.type)) {
    //    ● 可选服务仅有付费的情况下，选择授权网点后弹框提示
    // ● 可选服务有【质保服务】【安心保】【极加22版】【不计免赔】情况下，选择了没有对应服务类型的授权网点后弹框提示
    // const devicesItem = getDevicesItem()
    let needTips = false // 是否需要提示
    if (!isPlan.value) {
      if (!data.service_types.includes(QUALITY)) {
        needTips = true
      }
    } else {
      // 判断当前设备是否只有付费服务
      if (popupInfo.value.serviceType.length === 1 && popupInfo.value.serviceType[0] === NO) {
        needTips = true
      } else if (!data.service_types.includes(popupInfo.value.serviceType[0])) {
        needTips = true
      }
    }

    // if (needTips && !hasShowTips) {
    //   try {
    //     await showConfirmModal({
    //       message: '授权服务站仅能进行付费维修，是否同意?',
    //       className: 'repair-dialog',
    //     })
    //     hasShowTips = true
    //   } catch (error) {
    //     return
    //   }
    // }
  }
  selectedValue.value = data.guid
  setMarker([data.lng, data.lat])
}

async function nextHandle() {
  addNetworkListKeepAlive() // 添加网点列表keepalive
  const selectedItem = dataList.value.filter((item) => item.guid === selectedValue.value)[0]
  setNetworkInfo(selectedItem)
  if (!from) {
    $router.push({
      name: 'malfunction-repair-fault-submit',
      query: {
        on_site_exemption: on_site_exemption.value,
      },
    })
  } else {
    if (from === 'order-detail') {
      // 需要处理订单修改网点的问题
      showToastLoading({
        message: '更新中...',
      })
      try {
        await changeOrderRepairWahouse(orderGuid, {
          warehouse_guid: selectedItem.guid,
          warehouse_type: selectedItem.type,
        })
        showToastSuccess('更新成功')
        // 清除缓存, 使得详情页面可以更新
        removeServiceOrderKeepAlive()
        setTimeout(() => {
          MalfunctionRepairOrderDetailStorage.clear()
          $router.go(-1)
        }, 1500)
        return
      } catch (e) {
        commonErrorHandle(e)
        return
      }
    }
    $router.go(-1)
  }
}
// 一键提单
async function submitOrder() {
  try {
    await showConfirmModal({
      className: 'fault-module',
      title: '确定提交？',
    })
  } catch (error) {
    console.log('error', error)
    return
  }
  const devices: Array<MalfunctionRepairDeviceItem> = MalfunctionRepairSelectedDevicesStorage.get()
  const selectedItem = dataList.value.filter((item) => item.guid === selectedValue.value)[0]
  const params: CreateMulfunctionRepairOrderParams = devices.map((item) => {
    return {
      process_type: item.type === 1 ? 'P_SERIAL' : 'EQ_OTHER',
      serial_number: item.serial_number,
      images: [] as string[],
      logs: [guid],
      is_boom: false, // 非炸机才有一键提单
      description: '',
      lat: locationInfo.value.lat + '',
      lng: locationInfo.value.lng + '',
      repair_warehouse_guid: selectedValue.value,
      repair_warehouse_type: selectedItem.type,
      receive_express: {
        name: '',
        phone: '',
        province: '',
        city: '',
        area: '',
        address: '',
      },
      is_on_site_exemption: 0,
      annex: [] as any[],
      is_pay: 0,
      is_warning: 1,
      warning_guid: warningGuid,
    }
  })
  try {
    showToastLoading()
    await createOrder(params)
    showNormalToast('提单成功')
    setTimeout(() => {
      $router.replace({
        name: 'malfunction-repair-order-list',
        query: {
          from: 'oneClickSubmit',
        },
      })
    }, 1500)
  } catch (error) {
    // commonErrorHandle(error)
    clearToast()
    const errorObj = error as { message: string }
    showConfirmModal({
      title: '提单失败',
      message: errorObj?.message || '',
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
      showCancelButton: false,
    })
  }
}
function initMessageTips() {
  // 提示信息加载
  if (from) {
    // 没有from信息的时候才是提单时进来的情况
    return
  }
  // 未定责的显示 有定责要等到请求网点接口之后再显示
  // if (!guid) {
  //   showPopup.value = true
  // }
}

function initPageHandle() {
  initMap()
  initMessageTips()
  nextTick(() => {
    useListScrollHandle('network-content-wrap')
  })
}

onMounted(async () => {
  let errorMessage = ''
  try {
    const info = await getUserLocation()
    if (info?.lat && info?.lng) {
      // 正常获取经纬度的时候
      locationInfo.value = {
        lat: Number(info.lat),
        lng: Number(info.lng),
      }

      nextTick(() => {
        initPageHandle()
      })
      return
    }
    if (info?.unAuth) {
      errorMessage = '当前未获得您获取经纬度的授权，即将返回上一步'
    }
  } catch (error: unknown) {
    errorMessage = (error as { message: string })?.message
  }
  try {
    await showConfirmModal({
      title: '提示',
      confirmButtonText: '我知道了',
      showCancelButton: false,
      message: errorMessage || '获取经纬度失败',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
    })
  } catch (error) {
    console.log('error', error)
  }
  if (hasWarningGuid.value) {
    // 若是一键提单跳转过来的，直接退出app即可
    appHost.goAppBack()
  } else {
    $router.go(-1)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "选择维修网点" }),
    (!!locationInfo.value?.lat && !!locationInfo.value?.lng)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(NetworkHeaderTips),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              ref_key: "box",
              ref: box,
              class: "map-box"
            }, null, 512)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(Search), {
                modelValue: keywords.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keywords).value = $event)),
                modelModifiers: { trim: true },
                onSearch: keywordChangeHandle,
                placeholder: "输入关键词",
                class: "search-component-wrap"
              }, {
                "left-icon": _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode(_unref(PullRefresh), {
              modelValue: _unref(refreshing),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(refreshing) ? (refreshing).value = $event : null)),
              onRefresh: _unref(onRefresh),
              class: "list-wrap",
              id: "network-content-wrap"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(List), {
                  loading: _unref(loading),
                  "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null)),
                  error: _unref(requestError),
                  "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => (_isRef(requestError) ? (requestError).value = $event : null)),
                  finished: _unref(finished),
                  offset: 200,
                  "finished-text": _unref(finishedText),
                  onLoad: _unref(queryHandle),
                  class: _normalizeClass(["list-container", _unref(dataList).length === 0 ? 'empty-wrap' : ''])
                }, {
                  error: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, " 加载失败：请检查网络是否通畅，或尝试使用其他手机网络提单;错误提示：" + _toDisplayString(errorMessage.value), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(RadioGroup), {
                      class: "radio-wrap xa-radio-group",
                      modelValue: selectedValue.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedValue).value = $event)),
                      "checked-color": "#00C378"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "list-item",
                            key: item.guid,
                            onClick: ($event: any) => (listItemClick(item))
                          }, [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_unref(Radio), {
                                name: item.guid
                              }, null, 8, ["name"])
                            ]),
                            _createVNode(NetworkInfoItem, { item: item }, null, 8, ["item"])
                          ], 8, _hoisted_6))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["loading", "error", "finished", "finished-text", "onLoad", "class"])
              ]),
              _: 1
            }, 8, ["modelValue", "onRefresh"]),
            (_unref(warningGuid))
              ? (_openBlock(), _createBlock(CommonFooterNextButton, {
                  key: 0,
                  onClick: submitOrder,
                  title: "提交服务单据",
                  disabled: !selectedValue.value
                }, null, 8, ["disabled"]))
              : (_openBlock(), _createBlock(CommonFooterNextButton, {
                  key: 1,
                  onClick: nextHandle,
                  title: "确定",
                  disabled: !selectedValue.value
                }, null, 8, ["disabled"]))
          ]),
          _createVNode(_unref(Popup), {
            show: showPopup.value,
            position: "bottom",
            class: "common-popup-wrap"
          }, {
            default: _withCtx(() => [
              _createVNode(PopupHeader, {
                title: "温馨提示",
                style: {"text-align":"center","justify-content":"center"},
                showClsoe: false
              }),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(ServiceTag, {
                      serviceType: popupInfo.value.serviceType
                    }, null, 8, ["serviceType"])
                  ])
                ]),
                (_unref(isShowLiabilityJudgment))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(RightReminder, {
                          info: popupInfo.value.liabilityJudgment
                        }, null, 8, ["info"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(canShowFualtInfo))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, _toDisplayString(popupInfo.value.description || '-'), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(canShowFualtInfo))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        (popupInfo.value.images.length)
                          ? (_openBlock(), _createBlock(CommonImagePreview, {
                              key: 0,
                              guids: popupInfo.value.images,
                              width: 72,
                              height: 72
                            }, null, 8, ["guids"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_22, "暂无数据"))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(RightReminder, {
                      info: popupInfo.value.authTip
                    }, null, 8, ["info"])
                  ])
                ]),
                _hoisted_26
              ]),
              _createVNode(CommonFooterNextButton, {
                onClick: _cache[5] || (_cache[5] = (e) => (showPopup.value = false)),
                title: "知道了"
              })
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(OnSiteBillLadingTipDialog, {
            ref_key: "OnSiteBillLadingTipDialogRef",
            ref: OnSiteBillLadingTipDialogRef,
            onGoBack: goBack,
            onContinue: continueHandle
          }, null, 512),
          _createVNode(OnSiteSystemTipDialog, {
            ref_key: "OnSiteSystemTipDialogRef",
            ref: OnSiteSystemTipDialogRef,
            remainNum: _unref(remainNum),
            onConfirm: onSiteSystemTipDialogConfirm
          }, null, 8, ["remainNum"])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})